var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanResources(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1768818003073,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 19854,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M514.68822 510.384203c134.953352 0 245.030179-111.579038 245.030179-248.380478 0-136.812695-110.076828-248.391734-245.030179-248.391733-134.969725 0-245.046552 111.579038-245.046552 248.391733 0 136.801439 110.076828 248.380477 245.046552 248.380478z",
    fill: "#231815",
    "p-id": 19855
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M426.792533 576.737291H596.668186l-59.28615 97.519862v26.562929l66.396067 240.68523 100.87016-364.519358c133.072519 5.684455 240.166415 116.280098 240.166415 250.692121v94.872575c0 48.316329-39.50875 87.836335-87.813823 87.836335H167.021657c-48.306096 0-87.836335-39.520006-87.836335-87.836335V827.679098c0-134.229876 106.813511-244.717048 239.648623-250.682911l100.847648 364.509125 66.396066-240.68523v-26.562929l-59.285126-97.519862z",
    fill: "#231815",
    "p-id": 19856
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanResources);
export default __webpack_public_path__ + "static/media/HumanResources.af9b93d4d76af6ee02a1fe9742985fdc.svg";
export { ForwardRef as ReactComponent };